import React from 'react';
import { useTranslation } from 'react-i18next';
import { HiBriefcase, HiWrenchScrewdriver, HiHomeModern, HiKey, HiShieldCheck, HiExclamationTriangle } from 'react-icons/hi2';
import SectionTitle from '../components/SectionTitle';
import InfoBox from '../components/InfoBox';
import TabGroup, { TabPanel } from '../components/TabGroup';

const WorkHousing = () => {
  const { t } = useTranslation();

  return (
    <div className="space-y-8">
      <SectionTitle level={1} icon={HiBriefcase}>
        {t('workHousing.title')}
      </SectionTitle>

      <TabGroup>
        {/* TAB 1: VOS DROITS */}
        <TabPanel tabId="rights">
          <section>
            <SectionTitle level={2} icon={HiShieldCheck}>
              {t('workHousing.rightsTitle')}
            </SectionTitle>
            <div className="bg-teal-50 dark:bg-teal-900/20 border-l-4 border-teal-600 dark:border-teal-400 p-4 rounded-r-lg">
              <ul className="space-y-3">
                {t('workHousing.rightsItems', { returnObjects: true }).map((item, index) => (
                  <li key={index} className="flex items-start">
                    <span className="text-teal-600 dark:text-teal-400 mr-2 mt-1 font-bold">✓</span>
                    <span className="text-gray-900 dark:text-white font-medium">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </section>

          <section>
            <SectionTitle level={2} icon={HiWrenchScrewdriver}>
              {t('workHousing.workRightsTitle')}
            </SectionTitle>
            <ul className="space-y-2">
              {t('workHousing.workRightsItems', { returnObjects: true }).map((item, index) => (
                <li key={index} className="flex items-start">
                  <span className="text-teal-600 dark:text-teal-400 mr-2 mt-1">•</span>
                  <span className="text-gray-700 dark:text-gray-300">{item}</span>
                </li>
              ))}
            </ul>
          </section>

          <section>
            <SectionTitle level={2} icon={HiHomeModern}>
              {t('workHousing.housingRightsTitle')}
            </SectionTitle>
            <ul className="space-y-2">
              {t('workHousing.housingRightsItems', { returnObjects: true }).map((item, index) => (
                <li key={index} className="flex items-start">
                  <span className="text-teal-600 dark:text-teal-400 mr-2 mt-1">•</span>
                  <span className="text-gray-700 dark:text-gray-300">{item}</span>
                </li>
              ))}
            </ul>
          </section>
        </TabPanel>

        {/* TAB 2: DÉMARCHES */}
        <TabPanel tabId="procedures">
          <section>
            <SectionTitle level={2} icon={HiWrenchScrewdriver}>
              {t('workHousing.workTitle')}
            </SectionTitle>
            <ul className="space-y-2">
              {t('workHousing.workItems', { returnObjects: true }).map((item, index) => (
                <li key={index} className="flex items-start">
                  <span className="text-teal-600 dark:text-teal-400 mr-2 mt-1">•</span>
                  <span className="text-gray-700 dark:text-gray-300">{item}</span>
                </li>
              ))}
            </ul>
          </section>

          <section>
            <SectionTitle level={2} icon={HiHomeModern}>
              {t('workHousing.housingTitle')}
            </SectionTitle>
            <ul className="space-y-2">
              {t('workHousing.housingItems', { returnObjects: true }).map((item, index) => (
                <li key={index} className="flex items-start">
                  <span className="text-teal-600 dark:text-teal-400 mr-2 mt-1">•</span>
                  <span className="text-gray-700 dark:text-gray-300">{item}</span>
                </li>
              ))}
            </ul>
          </section>

          <section>
            <SectionTitle level={3} icon={HiKey}>
              {t('workHousing.accommodationTitle')}
            </SectionTitle>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
              {t('workHousing.accommodationContent')}
            </p>
          </section>

          <InfoBox type="reflexe" title={t('workHousing.rememberTitle')}>
            <p>{t('workHousing.rememberContent')}</p>
          </InfoBox>
        </TabPanel>

        {/* TAB 3: SI PROBLÈME */}
        <TabPanel tabId="problems">
          <InfoBox type="important" title={t('workHousing.problemTitle')}>
            <p>{t('workHousing.problemContent')}</p>
          </InfoBox>

          <section>
            <SectionTitle level={2} icon={HiExclamationTriangle}>
              {t('workHousing.problemsTitle')}
            </SectionTitle>
            <ul className="space-y-2">
              {t('workHousing.problemsItems', { returnObjects: true }).map((item, index) => (
                <li key={index} className="flex items-start">
                  <span className="text-orange-600 dark:text-orange-400 mr-2 mt-1">!</span>
                  <span className="text-gray-700 dark:text-gray-300">{item}</span>
                </li>
              ))}
            </ul>
          </section>

          <InfoBox type="danger" title={t('workHousing.urgentTitle')}>
            <p>{t('workHousing.urgentContent')}</p>
          </InfoBox>
        </TabPanel>
      </TabGroup>
    </div>
  );
};

export default WorkHousing;
